import React, { useState } from 'react';
import { Box, Container } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { ContentCard, IntersectBox } from '../common';
import SectionWrapper from './SectionWrapper';

const MarketingAndSales: React.FC = () => {
  const [isIntersected, setIsIntersected] = useState<boolean>(false);

  const onInterSect = (entry: number) => {
    if (entry) {
      setIsIntersected(true);
    }
  };
  return (
    <IntersectBox
      justifyContent="center"
      w="100%"
      setSectionIntersect={onInterSect}
    >
      <Container maxW="1200px" px={500} mb={{ base: '72px', desktop: '152px' }}>
        <SectionWrapper>
          <ContentCard
            maxW="xl"
            header="Rectangular wall measurements"
            topBody="Estimating the square footage for a rectangular portion of your wall is the easiest measurement you will take. Measure the height and width of the wall. Don’t worry about any small obstructions like doors or windows as you will want some extra siding material to account for any gaps. Then, multiply the height by the width to get the total square footage. If you have a garage door or other large obstruction, you’ll need to measure the square footage and subtract it from the square footage of the wall."
          />
          <StaticImage
            width={380}
            style={{ margin: '0 auto' }}
            placeholder="blurred"
            alt="Measuring rectangular shapes"
            src="../../assets/images/vinyl siding estimator - rectangular.jpg"
            objectFit="contain"
          />
        </SectionWrapper>
        <SectionWrapper my={{ base: '72px', desktop: '150px' }}>
          <Box w="481px" h="362px" px={0} d={{ base: 'none', desktop: 'flex' }}>
            {isIntersected && (
              <StaticImage
                placeholder="blurred"
                src="../../assets/images/vinyl siding estimator - triangular.jpg"
                objectFit="contain"
                alt="Measuring triangular shapes"
                width={380}
              />
            )}
          </Box>
          <ContentCard
            maxW="xl"
            header="Triangular wall measurements"
            topBody="The initial process for triangular measurements is the same. Obtain the height at the peak of the triangle and measure the width. Multiplying the two together and then divide them by two to get the overall square footage for the triangular portion of your wall."
          />
          <Box mx="auto" d={{ base: 'flex', desktop: 'none' }}>
            {isIntersected ? (
              <StaticImage
                placeholder="blurred"
                src="../../assets/images/vinyl siding estimator - triangular.jpg"
                objectFit="contain"
                alt="Measuring triangular shapes"
                width={576}
              />
            ) : (
              <Box minH={{ base: '300px', tablet: '400px' }} />
            )}
          </Box>
        </SectionWrapper>
        <SectionWrapper>
          <ContentCard
            maxW="xl"
            header="Measuring other shapes"
            topBody="You may encounter some surfaces of the wall with different shapes. In this case, try breaking the surface down into parts composed of rectangles and triangles. If this can’t be done, you can either get a rough estimate using the height and width or do a Google search to find the square footage formula of that particular shape."
          />
          <StaticImage
            width={380}
            style={{ margin: '0 auto' }}
            placeholder="blurred"
            alt="Measuring other shapes"
            src="../../assets/images/vinyl siding estimator - other shapes.jpg"
            objectFit="contain"
          />
        </SectionWrapper>
      </Container>
    </IntersectBox>
  );
};

export default MarketingAndSales;
